import { render, staticRenderFns } from "./registration_answers.vue?vue&type=template&id=cdff8968&"
import script from "./registration_answers.vue?vue&type=script&lang=js&"
export * from "./registration_answers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports